// Utility function to preload images
export const preloadImages = (imageUrls) => {
    return Promise.all(
        imageUrls.map((url) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(url);
                img.onerror = () => reject(url);
                img.src = url;
            });
        })
    );
};

// Function to preload images for the next page
export const preloadNextPageImages = (applications, currentPage, applicationsPerPage) => {
    const nextPage = currentPage + 1;
    const startIndex = nextPage * applicationsPerPage;
    const endIndex = startIndex + applicationsPerPage;

    const nextPageApplications = applications.slice(startIndex, endIndex);
    const imageUrls = nextPageApplications
        .map(app => app.image)
        .filter(url => url && !url.includes('/Images/background.jpg')); // Skip fallback images

    if (imageUrls.length > 0) {
        preloadImages(imageUrls).catch(console.error);
    }
};
